import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import StackView from '../StackView';
var supportsFlexGap = null;

function getSupportsFlexGap() {
  if (typeof document !== 'undefined' && supportsFlexGap === null) {
    var div = document.createElement('div');
    div.style.display = 'flex';
    div.style.flexDirection = 'column';
    div.style.gap = '1px';
    div.appendChild(document.createElement('div'));
    div.appendChild(document.createElement('div'));
    document.body.appendChild(div);
    supportsFlexGap = div.scrollHeight === 1;
    document.body.removeChild(div);
  }

  return supportsFlexGap;
}

export function WrapView(_ref) {
  var children = _ref.children,
      spacing = _ref.spacing,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "spacing"]);

  var supportsFlexGap = getSupportsFlexGap();
  var styles = {
    basis: '100%'
  };

  if (spacing) {
    if (supportsFlexGap) {
      styles.gap = spacing;
    } else {
      styles.marginBottom = -spacing;
      styles['& > *'] = {
        marginRight: spacing,
        marginBottom: spacing
      };
    }
  }

  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal"
  }, restProps), /*#__PURE__*/React.createElement(StackView, {
    wrap: true,
    axis: "horizontal",
    css: styles
  }, children));
}